import React, { useState, useEffect } from "react";
import { FaSearch, FaEye, FaEdit, FaPlus, FaTimes, FaUsers } from "react-icons/fa";
import "./ProjectNavbar.css";

const Projects = ({ 
  onDeleteProject, 
  onAddProject, 
  selectedStatus, 
  onUpdateProject, 
  projects: externalProjects = [], 
  onProjectClick,
  isCEO,
  onManageEmployees
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [projects, setProjects] = useState(externalProjects);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    
    setProjects(externalProjects);
  }, [externalProjects]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const getProjectName = (project) => {
    return project.project_name || project.name || 'Unknown Project';
  };

  const getNumberOfBlocks = (project) => {
   
    
    if (project.originalData?.no_of_blocks !== undefined && project.originalData?.no_of_blocks !== null) {
      const blockCount = String(project.originalData.no_of_blocks).trim();
     
      if (blockCount === '' || blockCount === 'null' || blockCount === 'undefined') {
        return 'N/A Blocks';
      }
      return `${blockCount} Blocks`;
    }
    
    if (project.no_of_blocks !== undefined && project.no_of_blocks !== null) {
      const blockCount = String(project.no_of_blocks).trim();
    
      if (blockCount === '' || blockCount === 'null' || blockCount === 'undefined') {
        return 'N/A Blocks';
      }
      return `${blockCount} Blocks`;
    }
    
    if (project.numberOfBlocks !== undefined && project.numberOfBlocks !== null) {
      const blockCount = String(project.numberOfBlocks).trim();
     
      if (blockCount === '' || blockCount === 'null' || blockCount === 'undefined') {
        return 'N/A Blocks';
      }
      return `${blockCount} Blocks`;
    }
    
    if (project.blocks && project.blocks !== 'N/A Blocks') {
     
      return project.blocks;
    }
    
  
    return 'N/A Blocks';
  };

  const getProjectStatus = (project) => {
    return project.status || 'Pipelined';
  };

  const getProjectLocation = (project) => {
    return project.location || 'Unknown Location';
  };

  const getProjectId = (project) => {
    return project.id || project.project_id;
  };

  const filteredProjects = projects.filter((project) => {
    const projectName = getProjectName(project);
    const projectLocation = getProjectLocation(project);
    const projectStatus = getProjectStatus(project);
    
    const matchesSearch = projectName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         projectLocation.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = selectedStatus === "" || selectedStatus === undefined || projectStatus === selectedStatus;
    return matchesSearch && matchesStatus;
  });

  const handleDeleteProject = async (projectId) => {
    if (window.confirm("Are you sure you want to delete this project?")) {
      try {
        if (onDeleteProject) {
          await onDeleteProject(projectId);
        }
        
        setProjects(prev => prev.filter(p => getProjectId(p) !== projectId));
        
      } catch (error) {
     
        alert('Failed to delete project. Please try again.');
      }
    }
  };

  const handleViewProject = (project) => {
    setSelectedProject(project);
    setViewModalOpen(true);
  };

  const handleEditProject = (project) => {
    
    if (onUpdateProject) {
      onUpdateProject(project);
    }
  };

  const handleManageEmployees = (project) => {
   
    const projectWithId = {
      ...project,
      project_id: getProjectId(project),
      project_name: getProjectName(project)
    };
    
    if (onManageEmployees) {
      onManageEmployees(projectWithId);
    }
  };

  const handleProjectNameClick = (e, project) => {
    e.preventDefault();
    e.stopPropagation();
    

    
    const projectWithId = {
      ...project,
      project_id: getProjectId(project),
      project_name: getProjectName(project)
    };
    
    if (onProjectClick) {
      onProjectClick(projectWithId);
    }
  };

  const closeModals = () => {
    setViewModalOpen(false);
    setSelectedProject(null);
  };

  const formatProjectForView = (project) => {
  
    
    const vendorName = project.vendor_name || 
                       project.vendorName || 
                       project.originalData?.vendor_name ||
                       project.originalData?.vendorName ||
                       (project.vendor_id ? `Vendor ID: ${project.vendor_id}` : 'Not specified');
    
    const clientName = project.client_name || 
                       project.clientName || 
                       project.originalData?.client_name ||
                       project.originalData?.clientName ||
                       (project.client_id ? `Client ID: ${project.client_id}` : 'Not specified');
    
  
    
    return {
      name: getProjectName(project),
      blocks: getNumberOfBlocks(project),
      status: getProjectStatus(project),
      location: getProjectLocation(project),
      startDate: project.starting_date ? new Date(project.starting_date).toLocaleDateString() : 
                 (project.startDate ? new Date(project.startDate).toLocaleDateString() : 'Not specified'),
      vendorName: vendorName,
      clientName: clientName,
      quotation: project.amount_in_rupees || 
                 project.quotation || 
                 project.originalData?.amount_in_rupees || 
                 'Not specified',
      city: project.city || project.originalData?.city || 'Not specified',
      pincode: project.pincode || project.originalData?.pincode || 'Not specified',
      equipment: project.equipment || project.originalData?.equipment || 'Not specified'
    };
  };

  return (
    <div className="PN-00">
      <div className="PN-01">
        <div className="PN-02">
          <div className="PN-03">
            <FaSearch className="PN-04" />
          </div>
          <div className="PN-05">
            <input
              type="text"
              placeholder=" Search Project Details"
              value={searchQuery}
              onChange={handleSearch}
              className="PN-06"
            />
          </div>
        </div>
        
        {isCEO && (
          <div className="btn-container">
            <button className="PN-08" onClick={onAddProject}>
              <FaPlus className="PN-09" />
              Add Project
            </button>
          </div>
        )}
      </div>

      <section className="PN-10">
        <div className="PN-11">
          <div className="PN-12"><span>Project Name</span></div>
          <div className="PN-13"><span>No of Blocks</span></div>
          <div className="PN-14"><span>Status</span></div>
          <div className="PN-15"><span>Location</span></div>
          <div className="PN-16"><span>Actions</span></div>
        </div>
        <hr className="PN-17" />

        {filteredProjects.length === 0 ? (
          <div className="PN-20">
            <div className="PN-21">
              {selectedStatus ? 
                `No ${selectedStatus.toLowerCase()} projects found` : 
                (searchQuery ? 
                  `No projects match "${searchQuery}"` : 
                  "No projects found"
                )
              }
            </div>
            {projects.length === 0 && (
              <div className="no-projects-message">
                Click "Add Project" to create your first project.
              </div>
            )}
          </div>
        ) : (
          <>
            <div className="project-count-info">
              Showing {filteredProjects.length} of {projects.length} projects
            </div>
            {filteredProjects.map((project) => {
              const projectId = getProjectId(project);
              const projectName = getProjectName(project);
              const projectBlocks = getNumberOfBlocks(project);
              const projectStatus = getProjectStatus(project);
              const projectLocation = getProjectLocation(project);
              
           
              
              return (
                <div key={projectId} className="PN-22">
                  <div 
                    className="PN-23 clickable-project-name" 
                    onClick={(e) => handleProjectNameClick(e, project)}
                    title="Click to view expenses"
                  >
                    <span>{projectName}</span>
                  </div>
                  <div className="PN-24">
                    <span>{projectBlocks}</span>
                  </div>
                  <div className="PN-25">
                    <span className={`PN-26 PN-26--${projectStatus.toLowerCase().replace(/\s+/g, '-')}`}>
                      {projectStatus}
                    </span>
                  </div>
                  <div className="PN-27"><span>{projectLocation}</span></div>
                  <div className="PN-28">
                    <FaEye 
                      className="PN-29 icon-action" 
                      title="View Project" 
                      onClick={() => handleViewProject(project)}
                    />
                    {isCEO && (
                      <>
                        <FaEdit   
                          className="PN-30 icon-action" 
                          title="Edit Project" 
                          onClick={() => handleEditProject(project)}
                        />
                        <FaUsers
                          className="PN-31 icon-action"
                          title="Manage Employees"
                          onClick={() => handleManageEmployees(project)}
                        />
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </>
        )}
      </section>

      {viewModalOpen && selectedProject && (
        <div className="PN-32">
          <div className="PN-33">
            <div className="PN-34">
              <h3>Project Details</h3>
              <FaTimes className="PN-35" onClick={closeModals} />
            </div>
            <div className="PN-36">
              <div className="PN-37">
                {(() => {
                  const viewData = formatProjectForView(selectedProject);
                  return (
                    <>
                      <div className="PN-38">
                        <strong>Project Name:</strong> {viewData.name}
                      </div>
                      <div className="PN-39">
                        <strong>Number of Blocks:</strong> {viewData.blocks}
                      </div>
                      <div className="PN-40">
                        <strong>Status:</strong> 
                        <span className={`PN-41 PN-41--${viewData.status.toLowerCase().replace(/\s+/g, '-')}`}>
                          {viewData.status}
                        </span>
                      </div>
                      <div className="PN-42">
                        <strong>Location:</strong> {viewData.location}
                      </div>
                      <div className="PN-43">
                        <strong>Start Date:</strong> {viewData.startDate}
                      </div>
                      <div className="PN-44">
                        <strong>Vendor Name:</strong> {viewData.vendorName}
                      </div>
                      <div className="PN-45">
                        <strong>Client Name:</strong> {viewData.clientName}
                      </div>
                      <div className="PN-46">
                        <strong>Quotation:</strong> {viewData.quotation !== 'Not specified' ? `₹${parseFloat(viewData.quotation).toLocaleString()}` : 'Not specified'}
                      </div>
                      {viewData.city !== 'Not specified' && (
                        <div className="PN-47">
                          <strong>City:</strong> {viewData.city}
                        </div>
                      )}
                      {viewData.pincode !== 'Not specified' && (
                        <div className="PN-48">
                          <strong>Pincode:</strong> {viewData.pincode}
                        </div>
                      )}
                      {viewData.equipment !== 'Not specified' && (
                        <div className="PN-49-equipment">
                          <strong>Equipment:</strong> {viewData.equipment}
                        </div>
                      )}
                    </>
                  );
                })()}
              </div>
            </div>
            <div className="PN-49">
              <button className="PN-50" onClick={closeModals}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Projects;